app.controller('studentWelcome5Ctrl', [
    '$scope', '$interval', 'gameService', 'welcomeService', '$state', function ($scope, $interval, gameService, welcomeService, $state) {
        var vm = this;

        var idx = $scope.$parent.indexOfPage($scope);
        console.log("my index is " + idx);

        vm.gameService = gameService;
        vm.welcomeService = welcomeService;

        vm.timeRemainingSecs = 84010; // 23h, 20m, 10s

        vm.updateClockDisplay = function() {
            var trs = vm.timeRemainingSecs;
           
            var hr = parseInt(Math.floor(trs / 3600));
            trs -= (hr * 3600);

            var mr = parseInt(Math.floor(trs / 60));
            trs -= (mr * 60);
            
            vm.daysRemain = Math.floor(hr / 24.0);
            vm.hoursRemain = hr;
            vm.minutesRemain = mr;
            vm.secondsRemain = trs;
        }

        vm.updateClockDisplay();

        vm.countdownId = $interval(function() {
            vm.timeRemainingSecs -= 1;
            vm.updateClockDisplay();
        }, 1000);

        $scope.$on('$destroy', function() {
            $interval.cancel(vm.countdownId);
        });

        vm.prev = function() {
            $scope.$parent.prevPage();
        }

        vm.start = function() {
            gameService.setWelcomeFinished(true).then(function() {
                $state.go('student.exercises');
            });
        }
   }
]);